export default "__VITE_ASSET__8286e9f8__"